// Offers routes
export default [
  {
    path: 'sign-documents',
    name: 'sign-documents',
    redirect: 'sign-documents/index',
    component: () =>
      import(
        /* webpackChunkName: "signDocuments" */ '../views/signDocuments/SignDocuments.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'signDocuments',
        meta: {
          tabbable: true,
          tableKeys: ['signDocuments'],
          filterKeys: ['signDocuments'],
          formKeys: [],
          routePermissions: ['signatureUser'],
        },
        component: () =>
          import(
            /* webpackChunkName: "signDocumentsIndex" */ '../views/signDocuments/SignDocumentsIndex.vue'
          ),
      },
    ],
  },
];
